// ChatWidget: Manages the functionality of a chat widget on a web page
const ChatWidget = {
  // Properties
  chatButton: null,
  chatDetailsLink: null,
  shadowHostElement: null,
  
  // Initialize the chat widget
  init() {
    this.chatDetailsLink = document.querySelector('.enable-chat-details a');
    this.shadowHostElement = document.querySelector('[location-id="cFeT6J2nl4i0chn30Cnh"]');
    
    if (!this.chatDetailsLink || !this.shadowHostElement) {
      console.error('Required elements not found. Chat widget initialization failed.');
      return;
    }
    
    this.setupEventListeners();
  },
  
  // Set up event listeners
  setupEventListeners() {
    this.chatDetailsLink.addEventListener('click', this.handleChatDetailsClick.bind(this));
  },
  
  // Handle click on chat details link
  handleChatDetailsClick(event) {
    event.preventDefault();
    console.log('Triggering chat');
    this.openChatWidget();
  },
  
  // Open the chat widget
  openChatWidget() {
    if (!this.shadowHostElement) {
      console.error('Shadow host element not found. Cannot open chat widget.');
      return;
    }
    
    const shadowRoot = this.shadowHostElement.shadowRoot;
    if (!shadowRoot) {
      console.error('Shadow root not found. Cannot open chat widget.');
      return;
    }
    
    this.chatButton = shadowRoot.querySelector('#lc_text-widget--btn');
    if (!this.chatButton) {
      console.error('Chat button not found in shadow DOM. Cannot open chat widget.');
      return;
    }
    
    this.chatButton.click();
  }
};

// Initialize the chat widget when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  ChatWidget.init();
});